import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  applyTheme(primaryColor: string, onPrimaryColor: string, secondaryColor: string): void {
    const themeStyles = `
    :root {
      --brandtheme-primary: ${primaryColor};
      --brandtheme-on-primary: ${onPrimaryColor};
      --brandtheme-secondary: ${secondaryColor};
    }
  `;

    let styleElement = document.getElementById('dynamic-theme') as HTMLStyleElement;
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = 'dynamic-theme';
      document.head.appendChild(styleElement);
    }

    styleElement.innerHTML = themeStyles;
  }
}
